import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
// import ShareIcon from '@mui/icons-material/Share';
import { convertEpochTime, getEndpoint, getUrl, showMultipleAuthor, setCmsSeoData } from '../../../common/utils';
//import { SocialShareTwo } from "../SocialShareTwo/SocialShareTwo";
import './PodcastThree.css';
import Tag from "../../Tag/Tag";
//import { URL_PROTOCAL } from '../../Common/Constant';
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import MediaPlayerWrapper from '../MediaPlayerWrapper';
import bcrypt from 'bcryptjs-react';

PodcastThree.version = 1000;

PodcastThree.lang = 'en';
PodcastThree.langs = [
    'en'
];
PodcastThree.setLang = (lang: any) => {
    PodcastThree.lang = lang;
}


Object.defineProperty(PodcastThree, 'name', {
    writable: true,
    value: 'PodcastThree'
});

export function PodcastThree(props: any) {
    const [videoShowData, setVideoShowData] = useState<any>({});
    // const [view, setView] = useState(false);
    const { showAuthorName, showTags, showTimeStamp } = props;

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, [])

    const addExportedData = (object: any) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && object.folderId != null && object.folderId != "") {
            props.exportedKeys.pid = object.folderId;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
            && object.id != null && object.id != "") {
            props.exportedKeys.sectionid = object.id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && typeof object.authors != "undefined" && object.authors.length > 0) {
            props.exportedKeys.authorid = object.authors[0].id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && typeof object.kws != "undefined" && object.kws.length > 0) {
            const names = object.kws.map((item: any) => item.name).join(',');
            props.exportedKeys.tags = names;
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && videoShowData && Object.keys(videoShowData).length === 0
        && endpoint.SSRDataObj.items.length > 0) {
        setVideoShowData(endpoint.SSRDataObj.items[0])
        addExportedData(endpoint.SSRDataObj.items[0])
        setCmsSeoData(props, endpoint.SSRDataObj.items[0], "VideoShow");
    }

    const fetchComponentData = () => {
        let videoUrl = getUrl(props, 0, false, "MAIN", true);
        let headerString = '?' + videoUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(videoUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setVideoShowData(val.items[0])
                addExportedData(val.items[0])
                setCmsSeoData(props, val.items[0], "VideoShow");
            })
    }

    // const handleChange = () => {
    //     setView(!view);
    // };

    const getAuthorDetails = () => {
        const { upd, authors, pubInfo } = videoShowData;
        const { baseDomain } = pubInfo;

        return (
            <div className="ThemeTwoPodCastAuthor">
                {showAuthorName && authors && authors.length && <div className="ThemeTwoPodCastStoryAuthor">
                    <span className="podCastThemeTwoStoryByline"><span dangerouslySetInnerHTML={{ __html: showMultipleAuthor(authors, baseDomain) }}></span></span>
                    <div className="podAcstThemeTwoVideoStory">
                        {showTimeStamp && <span className="podAcstThemeTwoStoryDate">{convertEpochTime(upd, 'updated', 'MM-dd-yy h:mm a')}</span>}
                    </div>
                </div>
                }


            </div>
        )

    }

    const isDataAvailable = videoShowData && Object.keys(videoShowData).length > 0;

    let slikeId = '';

    if (isDataAvailable && videoShowData.media) {
        if (videoShowData.media.rmid === 10) {
            slikeId = 'yt' + videoShowData.media.id;
        } else {
            slikeId = videoShowData.media.id;
        }

    }

    return (
        <React.Fragment>
            <Grid className="podAcstThemeTwoPodCastShow">
                <Grid item sm={12} xs={12} className='videofullbox'>
                    <div>

                        {
                            typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) ?
                                <div className="podAcstThemeTwoPodCastBox">
                                    {isDataAvailable && videoShowData.media &&
                                        <div style={{ position: 'relative' }}>
                                            <img src={`/stresources/images/padcast.jpeg`} alt={videoShowData?.hl?.slice(0, 25)} title={videoShowData?.hl?.slice(0, 25)} loading="lazy"/>

                                        </div>
                                    }

                                </div>
                                :
                                <div>
                                    <MediaPlayerWrapper
                                        containerId={`playerContainer_${slikeId}`}
                                        apiKey="test403web5a8sg6o9ug"
                                        slikeId={slikeId}
                                        //slikeId="1xsbjps9ku"
                                        Pl_Type='Audio'
                                        autoPlay={true}
                                        skipAd={true}
                                        mute={false}
                                        playInBackground={true} /></div>
                        }
                    </div>
                </Grid>
                <Grid item md={12}>
                    <div className="podAcstThemeTwoVideoTitle">
                        <Typography className="podAcstThemeTwoStoryHeading" variant='h2'>
                            {videoShowData && videoShowData?.hl}
                        </Typography>
                    </div>
                    <Grid container item md={12} position={'relative'} direction="column">
                        {isDataAvailable && getAuthorDetails()}
                        {/* {<SocialShare visible={view} />}   */}
                    </Grid>
                    <div className="podAcstThemeTwoPodCastSummery">
                        <Typography>
                            {videoShowData && videoShowData.Story}
                        </Typography>
                    </div>
                </Grid>

                <Grid container direction="row" className='tag_dnone'>
                    <Grid item sm={12}>
                        {videoShowData && showTags && videoShowData.pubInfo && <Tag baseDomain={videoShowData.pubInfo.baseDomain} tagsData={videoShowData.kws} />}
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
